import { apis, apiHolder, apiHolder as api } from 'api';
import { getIn18Text } from 'api';
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
var EVENT_ID;
(function (EVENT_ID) {
    EVENT_ID["LOGIN_PAGE_VIEW"] = "pcLogin_view_LoginDetailPage";
    EVENT_ID["LOGIN_PAGE_CLICK"] = "pcLogin_click_login_loginPage";
})(EVENT_ID || (EVENT_ID = {}));
const trackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const getPageSourceInfo = (originPageSource) => {
    let fileid;
    let pageSource = originPageSource;
    if (pageSource === getIn18Text('YUANSHIQIDONGDENG')) {
        const hash = decodeURIComponent(window.location.hash);
        if (hash) {
            const isDoc = /^#\/?(?:doc)/i.test(hash);
            const isSheet = /^#\/?(?:sheet)/i.test(hash);
            const isFile = /^#\/?(?:share)\/#.*type=file/i.test(hash);
            if (isDoc)
                pageSource = 'doc';
            if (isSheet)
                pageSource = 'sheet';
            if (isFile)
                pageSource = 'file';
            const res = /^#\/.*\/#.*id=(\w*)/.exec(hash);
            if (res && res[1]) {
                fileid = res[1];
            }
        }
    }
    return {
        fileid,
        pageSource,
    };
};
export const doLoginPageViewDataTrack = (pageSource) => {
    trackerApi.track(EVENT_ID.LOGIN_PAGE_VIEW, Object.assign({}, getPageSourceInfo(pageSource)));
};
export const doLoginPageClickDataTrack = (pageSource, loginResult, loginFalseReason, type) => {
    trackerApi.track(EVENT_ID.LOGIN_PAGE_CLICK, Object.assign({ type: type || 'email', loginResult,
        loginFalseReason }, getPageSourceInfo(pageSource)));
};
